import { Component } from "react"
import { RouteComponentProps } from "react-router-dom"
import { Dashboard } from "./dashboard"

export class DashboardExternal extends Component<RouteComponentProps<{}>> {
    render() {
        return <Dashboard {...this.props} external={true} />
    }
}